import Layout from '@layout/Index'

export const customerTask = [
  {
    path: '/customer-task',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "CustomerTaskTable" */ './pages/CustomerTaskTable.vue'),
        name: '客户任务管理',
        meta: {
          title: '客户任务管理',
        },
      },
      {
        path: 'table/type/:type',
        component: () => import(/* webpackChunkName: "CustomerTaskTable" */ './pages/CustomerTaskTable.vue'),
        meta: {
          title: '客户任务管理',
        }
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "CustomerTaskForm" */ './pages/CustomerTaskForm.vue'),
        meta: {
          title: '新增客户',
        }
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "CustomerTaskForm" */ './pages/CustomerTaskForm.vue'),
        meta: {
          title: '编辑客户',
        }
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/customer-task/customer-task.route.js